module.exports = __webpack_public_path__ + "img/gowuchexiangq.7e830715.svg";